import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import { Button } from "zina-dogi-react";
import { Formik, Form, Field } from "formik";
import swal from "sweetalert";
import { utils } from "../../../utils/utils";

// import Select from "react-select";

class ApprovalModal extends Component {
    constructor(props) {
        super(props);
        this.data = null;
        this.state = {
            modal: false,
            approve: null
        };
    }

    toggle = approve => {
        this.setState({ modal: !this.state.modal, approve });
    };

    onSubmit = (values, formik) => {
        this.setState({ fail: true });
        const status = this.state.approve ? "approved" : "rejected";
        this.props
            .onSubmit({ ...values, status })
            .then(() => {
                formik.setSubmitting(false);
                this.toggle(this.state.approve);
            })
            .catch(error => {
                if (error && error.response && error.response.status === 400) {
                    swal({
                        title: "Warning!",
                        text: utils.computeError(error), 
                        icon: "warning",
                        timer: 60000,
                        button: true
                    });
                }
            });
    };

    validateGeneral = value => {
        let error;
        if (!value) {
            error = "This field is required";
        }
        return error;
    };

    renderError = (formik, type) => {
        if (formik.errors.hasOwnProperty(type) && formik.errors[type]) {
            return <small className="text-danger form-text">{formik.errors[type]}</small>;
        }
        return null;
    };

    render() {
        const status = this.state.approve ? "Approve" : "Reject";
        return (
            <div>
                <Modal isOpen={this.state.modal} toggle={this.toggle} size="lg" centered>
                    <ModalHeader>{status} NON SODE</ModalHeader>
                    <ModalBody>
                        <div style={{ width: "770px" }}>
                            <Formik onSubmit={this.onSubmit}>
                                {formik => (
                                    <Form className="form">
                                        <div className="fields">
                                            {/*{this.state.approve && (*/}
                                            {/*    <React.Fragment>*/}
                                            {/*        <Row>*/}
                                            {/*            <Col md={6}>*/}
                                            {/*                <div className="form-group">*/}
                                            {/*                    <label>Approved Quantity</label>*/}
                                            {/*                    <Field*/}
                                            {/*                        name="approved_quantity"*/}
                                            {/*                        type="number"*/}
                                            {/*                        validate={this.validateGeneral}*/}
                                            {/*                        className="form-control"*/}
                                            {/*                    />*/}
                                            {/*                    {this.renderError(formik, "approved_quantity")}*/}
                                            {/*                </div>*/}
                                            {/*            </Col>*/}
                                            {/*            <Col md={6}>*/}
                                            {/*                <div className="form-group">*/}
                                            {/*                    <label>Budget</label>*/}
                                            {/*                    <Field*/}
                                            {/*                        validate={this.validateGeneral}*/}
                                            {/*                        name="price"*/}
                                            {/*                        type="number"*/}
                                            {/*                        className="form-control"*/}
                                            {/*                    />*/}
                                            {/*                    {this.renderError(formik, "price")}*/}
                                            {/*                </div>*/}
                                            {/*            </Col>*/}
                                            {/*        </Row>*/}
                                            {/*    </React.Fragment>*/}
                                            {/*)}*/}
                                            <Row>
                                                <Col md={12}>
                                                    <div className="form-group">
                                                        <label>Comment</label>
                                                        <Field
                                                            name="comment"
                                                            validate={this.validateGeneral}
                                                            type="text"
                                                            className="form-control"
                                                        />
                                                        {this.renderError(formik, "comment")}
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className="row controls">
                                                {this.state.approve ? (
                                                    <Button
                                                        type="submit"
                                                        color="primary"
                                                        style={{ width: "175px" }}
                                                        className="mr-1"
                                                    >
                                                        Approve
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        type="submit"
                                                        color="primary"
                                                        style={{ width: "175px" }}
                                                        className="mr-1"
                                                    >
                                                        Reject
                                                    </Button>
                                                )}
                                                <Button
                                                    className="btn-danger mr-1"
                                                    onClick={this.toggle}
                                                    type="button"
                                                    name="Close"
                                                    style={{ width: "175px" }}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default ApprovalModal;
